import { render, staticRenderFns } from "./LeaveNew.vue?vue&type=template&id=978c679e"
import script from "./LeaveNew.vue?vue&type=script&lang=js"
export * from "./LeaveNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports